import React from 'react';
import { Checkbox, withStyles } from '@material-ui/core';

const BlueCheckbox = withStyles({
  root: {
    borderRadius: '5px',
    backgroundColor: 'rgba(90, 200, 245, 0.2)',
    width: '1rem',
    height: '1rem',
  },
  checked: {
    borderRadius: '5px',
    backgroundColor: '#5ac8f5',
    color: '#5ac8f5',
    width: '1rem',
    height: '1rem',
    '&:hover': {
      backgroundColor: '#5ac8f5',
    },
  },
})((props) => (
  <Checkbox
    checkedIcon={<BlueBox />}
    color="default"
    {...props}
    data-testid="checkbox"
  />
));

export default BlueCheckbox;

const BlueBox = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
    >
      <g>
        <g>
          <path
            fill="#5ac8f5"
            d="M2 7a5 5 0 0 1 5-5h17a5 5 0 0 1 5 5v17a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5z"
          />
          <path
            fill="none"
            stroke="#5ac8f5"
            strokeMiterlimit="20"
            strokeOpacity=".2"
            strokeWidth="4"
            d="M2 7a5 5 0 0 1 5-5h17a5 5 0 0 1 5 5v17a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5z"
          />
        </g>
      </g>
    </svg>
  );
};
